import connect from '@vkontakte/vk-connect';

export function VKWebAppClose() {
	connect.send("VKWebAppClose", { "status": "success" });
}